'use strict';

var _iso = require('../data/iso3166-2.json');

var _iso2 = _interopRequireDefault(_iso);

var _IoT = require('./IoT');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _IoT.setDataFile)(_iso2.default);